import { getPosthog, loadPosthog } from './posthog-lazy';

export function getPosthogDistinctId(): string | undefined {
  try {
    // undefined until the idle-time SDK load finishes
    const id = getPosthog()?.get_distinct_id?.();
    return id || undefined;
  } catch {
    return undefined;
  }
}

export function identifyPosthogUser(email: string): void {
  void loadPosthog().then((posthog) => {
    try {
      posthog?.identify?.(email, { email });
    } catch {
      // posthog may not be initialized
    }
  });
}
